const { filterSections } =
  await import(`./filter-sections.js?v=${Date.now()}`);
class SortOptions extends HTMLElement {
  constructor() {
    super();
    const options = this.querySelector(".js-sort");
    const drawer = document.querySelector(".filter-drawer");
    const section_id = drawer.dataset.sectionId ? drawer.dataset.sectionId : null;
    if (options) {
      options.addEventListener("change", (e) => {
        const url = new URL(window.location);
        url.searchParams.set("sort_by", e.target.value);
        history.pushState("sort", "", url);
        filterSections(url.toString() + `&section=${section_id}`);
      });
    }
  }
}
if (customElements.get("sort-options") === void 0) {
  customElements.define("sort-options", SortOptions);
}
